import type { GetAdminUserSubscriptions200SubscriptionsItem } from './getAdminUserSubscriptions200SubscriptionsItem';

export type GetAdminUserSubscriptions200 = {
  subscriptions?: GetAdminUserSubscriptions200SubscriptionsItem[];
  success?: boolean;
  userId?: string;
};
